// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1km7A","active":"styles_active__27riA","label":"styles_label__1a7Ob"};